export default __webpack_public_path__ + "static/media/Prashant.aa770706.webp";